import * as stylex from '@stylexjs/stylex';
import { styles } from '../../styles';
import { Button } from '@shared/ui/kit';
import { FC } from 'react';
import notifications from '../../assets/notifications.webp';

type EroorInviteProps = {
  onRetry?: () => void;
  title?: string;
  subTitle?: string;
};

export const ErrorInvite: FC<EroorInviteProps> = ({ onRetry, title, subTitle }) => (
  <div>
    <div {...stylex.props(styles.content)}>
      <img src={notifications} alt="Уведомление" {...stylex.props(styles.statusIllustration)} />
      <p {...stylex.props(styles.title)}>{title || 'Непредвиденная ошибка'}</p>
      <div {...stylex.props(styles.titleStatusBlock)}>
        <p {...stylex.props(styles.titleStatus)}>
          {subTitle ||
            'Что-то пошло не так, но мы об этом уже знаем. Попробуй обновить страницу или повторить попытку через несколько минут'}
        </p>
      </div>
      <Button variant="accent" onClick={onRetry}>
        Обновить страницу
      </Button>
    </div>
  </div>
);
